import React, {useState, useEffect, useRef} from 'react'
import firebase from '../../firebase/config'
import {Link, useHistory, useLocation} from 'react-router-dom';
import moment from 'moment';
import * as XLSX from "xlsx";
import { createRef } from 'react';
import { useForm } from "react-hook-form";
import UserGuide from 'react-user-guide';
import ModalGuide from '../../components/ModalGuide';
import utils from '../../firebase/utils';
import Compress from "react-image-file-resizer";

function AllPromotions() {

  const history = useHistory()  
  const data = useLocation()
  const {register, handleSubmit, errors} = useForm();
  
  const [products, setProducts] = useState([])
  const [productsTypes, setProductsTypes] = useState([])
  const [palabrasClave, setPalabrasClave] = useState([])
  const [localidades, setLocalidades] = useState([])
  const [species, setSpecies] = useState([])
  const [selectedProducts, setSelectedProducts] = useState([])
  
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [palabra, setPalabra] = useState("")
  const [localidadId, setLocalidad] = useState("")
  const [btnMessage, setBtnMessage] = useState("Subir producto");
  
  const [countryInfo, setCountryInfo] = useState({})
  const [user, setUser] = useState({})
  const [product, setProduct] = useState({})

  const [update, setUpdate] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [deliveryAplica, setDeliveryAplica] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [walkinModal, setWalkinModal] = useState(false);
  
  const inputSku = useRef(null)
  const inputName = useRef(null)
  const inputDesc = useRef(null)
  const inputWord = useRef(null)
  const inputPeso = useRef(null)
  const inputPrice = useRef(null)
  const inputCantidad = useRef(null)
  const inputMinima = useRef(null)
  
  const hiddenFileInput = useRef(null);
  const [searchName, setSearchName] = useState(null)
  const [searchType, setSearchType] = useState(null)
  const [searchCategorie, setSearchCategorie] = useState(null)
  const [searchStatus, setSearchStatus] = useState(null)

  const razas = [
    "Sénior",
    "Adulto",
    "Cachorro",
    "Todos",
  ]

  const valores = [
    "Unidad",
    "Gramo",
    "Kilo",
    "Mililitro",
    "Litro",
    "Cápsula",
    "Galones",
    "Cajas",
    "Paquetes",
    "Docenas",
    "Libras",
    "Onzas",
  ]

    const [prodInfo, setProdInfo] = useState({
      sku: "",
      titulo: "",
      peso: "",
      pesoUnidad: "",
      precio: 0,
      existenciaMinima: 0,
      descripcion: "",
      cantidad: 0,
      dirigido: "Valor",
      continuarVendiendo: false,
      categoria: "",
      tipoMascota: "Valor",
    })
    const [prodUInfo, setProdUInfo] = useState({
      sku: null,
      titulo: null,
      precio: null,
      pesoValor: null,
      pesoUnidad: null,
      existenciaMinima: null,
      descripcion: null,
      cantidad: null,
      dirigido: null,
      continuarVendiendo: null,
      categoria: null,
      tipoMascota: null,
    })

    const [step1, setStep1] = useState(false);
    const [step2, setStep2] = useState(false);
    const [step3, setStep3] = useState(false);
    const [step4, setStep4] = useState(false);
    const [step5, setStep5] = useState(false);
    const [step6, setStep6] = useState(false);
    const [step7, setStep7] = useState(false);
    const [step8, setStep8] = useState(false);
    const [step9, setStep9] = useState(false);
    const [step10, setStep10] = useState(false);
    const [step11, setStep11] = useState(false);
    const [step12, setStep12] = useState(false);
    const [step13, setStep13] = useState(false);
    const [stepStart, setStepStart] = useState(false);

    const [file, setFile] = useState(null);
    const [url, setURL] = useState("");
    const [src, setImg] = useState('');
    const url2 = window.location.href;
    


    const handleClick = event => {
      hiddenFileInput.current.click();
    };

    async function handleChange(e) {
      var file = e.target.files[0]
      Compress.imageFileResizer(
        file,
        600,
        300,
        "JPEG",
        10,
        0,
        (uri) => {
          setFile(uri)
          console.log(uri)
        },
        "file",
        600,
        300
      )
      setImg(URL.createObjectURL(file))
    }
    
    const getLocalidades = async(aliadoId) =>{
      let tipos = [];
      await firebase.db.collection('Localidades').where("aliadoId", "==", aliadoId)
      .get().then(val => {
        val.docs.forEach(item=>{
          tipos.push(item.data())
          tipos.sort()
        })
        setLocalidades(tipos)
      })
    }
    
    function filterName(list, val) {
      let tipos = []
      for(let i = 0; i < list.length; i++){
        
        let u = list[i].titulo
        let uLower = u.toLowerCase()

        if( uLower.includes(val.toLowerCase()) ){
          tipos.push(list[i])
        }
      }
      return tipos
    }
    
    function filterType(list, val) {
      let tipos = []
      for(let i = 0; i < list.length; i++){
        
        let u = list[i].tipoPromocion !== undefined ? list[i].tipoPromocion.toString() : ""

        if( u.includes(val) ){
          tipos.push(list[i])
        }
      }
      return tipos
    }
    
    function filterCategorie(list, val) {
      let tipos = []
      for(let i = 0; i < list.length; i++){
        let u = list[i].categoria
        if(u === val){
          tipos.push(list[i])
        }
      }
      return tipos
    }

    const getPromotions = async(aliadoId) =>{
      let tipos = [];
      await firebase.db.collection('Promociones').where("aliadoId", "==", aliadoId).get().then(val => {
        val.docs.forEach(item=>{
          let a = {
            ...item.data(),
            countedItems: 0,
            fecha: moment(item.data().createdOn.toDate()).format("DD/MM/YYYY"),
          }
          tipos.push(a)
          tipos.sort()
        })

        let allList = tipos
        let filteredName = searchName ? filterName(tipos, searchName) : allList
        let filteredSku = searchType !== "Todas" && searchType ? filterType(filteredName, searchType) : filteredName

        setProducts(filteredSku.sort((a, b) => b.createdOn - a.createdOn))

      })
    }

    const wrapperRef = useRef(null);
    const excelBtn = useRef(null);
    const pdfBtn = useRef(null);

    function handleDownload(){
      excelBtn.current.click();
      pdfBtn.current.click();
    }

    useOutsideAlerter(wrapperRef);

    function useOutsideAlerter(ref) {
      useEffect(() => {

        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
              step1 && setStep1(false)
              step2 && setStep2(false)
              step3 && setStep3(false)
              step4 && setStep4(false)
            }
        }
      
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [ref]);
    }
    
    const SuccessComponent = ({msg}) => {
        return (
            <div className="success-alert">
                <span className="material-icons mr-2">done</span>
                {msg}
                <div onClick={()=>{setSuccess(false)}} className="material-icons ml-2 cursor-pointer">close</div>
            </div>
        )
    }

    const ErrorComponent = ({msg}) => {
      return (
          <div className="error-alert">
              <span className="material-icons mr-2">error</span>
              {msg}
              <div onClick={()=>{setError(false)}} className="material-icons ml-2 cursor-pointer">close</div>
          </div>
      )
    }
    
    useEffect(() => {
        firebase.getCurrentUser().then((val)=>{
          setUser(val)
          getPromotions(val.aliadoId)
          getLocalidades(val.aliadoId)
          setDeliveryAplica(val.delivery > 0 && val.delivery !== null ? true : false)
          firebase.getCountryInfo(val.pais).then((val)=>{
            setCountryInfo(val.data()) 
          })
        });

    }, [])


    return (
      
        <div className="main-content-container container-fluid px-4">
          {error && <ErrorComponent msg={errorMsg === "" ? "Todos los campos son requeridos" : errorMsg}/>}
          {success && <SuccessComponent msg={successMsg === "" ? "Promoción cargado exitosamente" : successMsg}/>}
        
          
            <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
              <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                <div className="row align-items-center">
                  <div className="col">
                    <p className="page-title bold"><Link className="color-white mr-3 light" to="/configuration">Configuración</Link> <Link className="color-white light" to="/configuration/promotions">Promociones</Link></p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-1 mb-0 level-1">
                <div className="row align-items-center justify-content-space-around level-2">
                  <i onClick={()=>{}} className="material-icons color-white display-5 cursor-pointer">help_outline</i>
                </div>
              </div>
            </div>

            <div className="my-3 row no-gutters align-items-center">
                <div className="form-group mr-3 mb-0 col-lg-2">
                    <input type="text" placeholder="Nombre de la promoción" className="form-control" onChange={(e)=>{ setSearchName(e.target.value) }}/>
                </div>
                <div className="form-group mr-3 mb-0 col-lg-2">
                    <select className="form-control" onChange={(e) => { setSearchType(e.target.value) }}>
                        <option value="">Tipo</option>
                        <option value="Producto">Producto</option>
                        <option value="Servicio">Servicio</option>
                        <option value="Combo">Combo</option>
                        <option value="Todos">Todos</option>
                    </select>
                </div>
                <div className="form-group mr-3 mb-0 col-lg-2">
                    <select className="form-control" onChange={(e) => { setSearchStatus(e.target.value) }}>
                        <option value="">Estatus</option>
                        <option value="Activo">Activo</option>
                        <option value="Borrador">Borrador</option>
                        <option value="Todos">Todos</option>
                    </select>
                </div>

                <button className="btn btn-primary mr-3 col-lg-1" onClick={()=>{getPromotions( user.aliadoId )}}><i className="material-icons">search</i></button>

                <Link to="/promotions/new-promotion" className="btn btn-primary mr-3">
                    Agregar nueva promoción<i className="material-icons ml-2">add</i>
                </Link>

            </div>
            
            <div className="position-relative">

                <div className="row-products-container-title">
                    <div className="row-products-container-img"></div>
                    <div className="row-products-container-img"></div>
                    <div className="row-products-container-body">
                        <p className="row-products-container-title-title">Nombre</p>
                        <p className="row-products-container-title-cat">Tipo</p>
                        <p className="row-products-container-title-price">Cupos</p>
                        <p className="row-products-container-title-stock">Órdenes cantidad</p>
                        <p className="row-products-container-title-stock">Órdenes total</p>
                    </div>
                </div>
                
                { products.length > 0 ? products.map((prod) => {
                    let precioRounded = Math.round(prod.precio * 100) / 100
                    return(
                    <div onClick={()=>{ 
                      history.push({
                        pathname: "/promotions/detail", 
                        state: { promoId: prod.promoId, promotion: prod}
                      })
                     }} className="row-products-container" key={prod.promoId}>
                        <div className="row-products-container-checkbox" style={{marginRight: "46px"}}>
                            <input type="checkbox" className="" />
                        </div>
                        <img src={prod.urlImagen} alt="" className="row-products-container-img" />
                        <div className="row-products-container-body">
                          <p className="row-products-container-p-title">{prod.titulo}</p>
                          <p className="row-products-container-p-cat">{prod.categoriaPromo}</p>
                          <p className="row-products-container-p-price">{prod.cupos}</p>
                          <p className="row-products-container-p-stock">{prod.ordersTotal ?? "-"}</p>
                          <p className="row-products-container-p-stock">{prod.ordersAmount ?? "-"}</p>
                        </div>
                      </div>
                    )
                    }) : <div className="text-center"><p>No hay promociones</p></div> 
                }
                
            </div>

          </div>
    )

}

export default AllPromotions
